import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

// loading
$(function () {
	var webStorage = function () {
		if (sessionStorage.getItem('access')) {
			$('.loading').css({ 'display': 'none', 'opacity': '0', 'visibility': 'hidden', 'z-index': '-999999' });
			setTimeout(function () {
				jQuery(function ($) {
					$('.js-topMv-slik, .js-topBusiness-slik').on('init', function () {
						$('.slick-slide[data-slick-index="0"]').addClass('slick-animation');
						})
						.slick({
							autoplay: true,
							infinite: true,
							fade: true,
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							speed: 4200,
							autoplaySpeed: 4200,
							pauseOnFocus: false,
							pauseOnHover: false,
						})
						.on({
						beforeChange: function (event, slick, currentSlide, nextSlide) {
						$(".slick-slide", this).eq(nextSlide).addClass("slick-animation");
						
						$(".slick-slide", this).eq(currentSlide).addClass("stop-animation");
						},
						afterChange: function () {
						$(".stop-animation", this).removeClass("stop-animation slick-animation");
						},
					});
				});
			}, 0);
		} else {
			sessionStorage.setItem('access', 'true');
			setTimeout(function () {
				$('.loading').fadeIn(0);
			}, 0);
			setTimeout(function () {
				$('.loading__logo').addClass("is-on");
			}, 200);
			setTimeout(function () {
				$('.loading__logo').removeClass("is-on");
			}, 2800);
			setTimeout(function () {
				$('.loading__ttl').addClass("is-on");
			}, 5000);
			setTimeout(function () {
				jQuery(function ($) {
					$('.js-topMv-slik, .js-topBusiness-slik').on('init', function () {
						$('.slick-slide[data-slick-index="0"]').addClass('slick-animation');
						})
						.slick({
							autoplay: true,
							infinite: true,
							fade: true,
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							speed: 4200,
							autoplaySpeed: 4200,
							pauseOnFocus: false,
							pauseOnHover: false,
						})
						.on({
						beforeChange: function (event, slick, currentSlide, nextSlide) {
						$(".slick-slide", this).eq(nextSlide).addClass("slick-animation");
						
						$(".slick-slide", this).eq(currentSlide).addClass("stop-animation");
						},
						afterChange: function () {
						$(".stop-animation", this).removeClass("stop-animation slick-animation");
						},
					});
				});
			}, 7500);
			setTimeout(function () {
				$('.loading').fadeOut(3400);
			}, 8000);
		}
	}
	webStorage();
});


gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function () {

	ScrollTrigger.create({
		trigger: '.js-fixedNav-trigger',
		start: 'top 80%',
		end: 'bottom bottom',
		// markers: true,
		toggleClass: {
			targets: ".cmn-fixedNav-list",
			className: "is-on"
		},
	});

	ScrollTrigger.create({
		trigger: '.js-recruit-trigger',
		endTrigger: '.js-recruit-trigger-end',
		start: 'top bottom',
		end: 'bottom bottom',
		// markers: true,
		toggleClass: {
			targets: ".recruit-bt,.recruit-bt.is-fixed",
			className: "is-on"
		},
	});

	gsap.to('.topMessage-bgTxtList', {
		x: 800,
		scrollTrigger: {
			trigger: '.js-topMessage-trigger',
			start: 'top center' ,
			end: 'bottom center',
			scrub: 4, //２秒間余韻で動く
			// markers: true,
		},
		stagger: {
			from: "start", //左からアニメーション start、center、edges、random、endが指定できる
			amount: 0.1 //どのくらいの割合でズラすか
			 }
	});

	ScrollTrigger.create({
		trigger: '.companySec02-ttlList',
		start: '-40% 70%',
		// end: 'bottom center',
		// markers: true,
		once: true,
		toggleClass: {
			targets: ".companySec02-ttlList",
			className: "is-on"
		},
	});

	ScrollTrigger.create({
		trigger: '.js-recruit01-trigger',
		start: 'top 70%',
		// end: 'bottom center',
		// markers: true,
		once: true,
		toggleClass: {
			targets: ".recruit01__ttlEn, .recruit01-list-ttlItem__ttl",
			className: "is-on"
		},
	});

	Array.prototype.slice.call(document.querySelectorAll('.cmn-ttl01'),0).forEach(function(item) {
		gsap.from(
			item,
			{
				scrollTrigger: {
					trigger: item,
					start: '-20% 70%',
					toggleClass: 'is-on',
					once: true,
					// markers: true,
				},
			},
		);
	});

	Array.prototype.slice.call(document.querySelectorAll('.cmn-subTtl01'),0).forEach(function(item) {
		gsap.from(
			item,
			{
				scrollTrigger: {
					trigger: item,
					start: '-40% 70%',
					toggleClass: 'is-on',
					once: true,
					// markers: true,
				},
			},
		);
	});

	Array.prototype.slice.call(document.querySelectorAll('.lower-leadBox-txt__ttl'),0).forEach(function(item) {
		gsap.from(
			item,
			{
				scrollTrigger: {
					trigger: item,
					start: '-40% 70%',
					toggleClass: 'is-on',
					once: true,
					// markers: true,
				},
			},
		);
	});

	Array.prototype.slice.call(document.querySelectorAll('.lower-ttlEn'),0).forEach(function(item) {
		gsap.from(
			item,
			{
				scrollTrigger: {
					trigger: item,
					start: '-40% 70%',
					toggleClass: 'is-on',
					once: true,
					// markers: true,
				},
			},
		);
	});

});
